import { toast } from 'react-toastify'

export const handleError = (status, data) => {
	// State
	status.isLoading = false
	status.isError = true

	// Error Message
	status.message = data?.message
	status.statusCode = data?.statusCode
}
export const handleSuccess = (status, data) => {
	// State
	status.isLoading = false
	status.isSuccess = true

	// Error Message
	status.message = data?.message
	status.statusCode = data?.status
}
export const handleLoading = (status, message = 'Loading...') => {
	status.isLoading = true
	status.message = message
}
// TODO: get ToastID to persist
// Note, pass clearState in as arrow function
export const handleStatus = (status, clearState, config) => {
	config = {
		isSuccess: {
			toast: true,
			callback: null,
			...config?.isSuccess,
		},
		isError: {
			toast: true,
			callback: null,
			...config?.isError,
		},
		isLoading: {
			toast: true,
			callback: null,
			...config?.isLoading,
		},
	}

	const toastId = status.name
	// if (!status.message || !status.name) return
	// If loading toast was being displayed, update it, if not, make one if enabled in config, otherwise clear toasts
	if (status.isSuccess) {
		config.isSuccess.toast && status.message
			? toast.isActive(toastId)
				? toast.update(toastId, {
						render: status.message,
						type: toast.TYPE.SUCCESS,
						autoClose: 3000,
						isLoading: false,
				  })
				: toast.success(status.message)
			: toast.dismiss(toastId)

		config.isSuccess.callback && config.isSuccess.callback()

		clearState && clearState(status)
	}
	if (status.isError) {
		config.isError.toast && status.message
			? toast.isActive(toastId)
				? toast.update(toastId, {
						render: status.message,
						type: toast.TYPE.ERROR,
						autoClose: 3000,
						isLoading: false,
				  })
				: toast.error(status.message)
			: toast.dismiss(toastId)

		config.isError.callback && config.isError.callback()
		clearState && clearState(status)
	}

	if (status.isLoading) {
		if (config.isLoading.toast) toast.loading(status.message, { toastId, autoClose: 5000 })

		config.isLoading.callback && config.isLoading.callback()
	}
}

export const handleToast = (promise, config) => {
	config = {
		isSuccess: {
			toast: true,
			callback: null,
			message: 'Success',
			...config?.isSuccess,
		},
		isError: {
			toast: true,
			callback: null,
			message: 'Error',

			...config?.isError,
		},
		isLoading: {
			toast: true,
			callback: null,
			message: 'Loading...',

			...config?.isLoading,
		},
	}

	const promiseFunc = () => promise

	toast.promise(promiseFunc, {
		pending: config.isLoading.message,
		success: config.isSuccess.message,
		error: config.isError.message,
	})
}

export const getAuth = state => {
	const { user, token, refreshToken, currBranch, type } = state.auth

	return { user, token, refreshToken, currBranch, type }
}
export const clearState = (state, status, statusObj) => {
	if (statusObj) {
		const newStatusObj = status
		state.status[statusObj.name] = newStatusObj[statusObj.name]

		return state
	}

	state.status = status
	return state
}

export const rejectWithValue = (thunkAPI, err, params) => {
	if (err?.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx

		if (params?.debug) {
			console.log(err.response.data)
			console.log(err.response.status)
			console.log(err.response.headers)
		}

		if (
			params?.message == 'Null token' ||
			(params?.logout && err.response.status == 400) ||
			err.response.status == 401 ||
			params?.status == 400 ||
			params?.status == 401
		) {
			thunkAPI.dispatch(params.callback())
			params?.callback && thunkAPI.dispatch(params.callback())
		}
		return thunkAPI.rejectWithValue({
			data: {
				message: params?.message || err.response.data.message,
				statusCode: params?.status || err.response.status,
			},
		})
	} else if (err?.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		// TODO: redirect to 404 page
		if (params?.debug) console.log(err.request)
		return thunkAPI.rejectWithValue({
			data: {
				message: `We couldn't connect to our servers right now. Please try again later.`,
				statusCode: 500,
			},
		})
	} else {
		// Something happened in setting up the request that triggered an Error
		if (params?.debug) console.log('Error', err?.message)
		return thunkAPI.rejectWithValue({
			data: {
				message: params?.message || err?.message || params?.logout,
				statusCode: params?.status || null,
			},
		})
	}
}

/* Pass func in as arrow function */
export const debounce = (func, delay) => {
	let timer

	return function () {
		let self = this
		let args = arguments
		clearTimeout(timer)
		timer = setTimeout(() => {
			func.apply(self, args)
		}, delay)
	}
}

export const throttle = (callback, interval) => {
	let enableCall = true

	return function (...args) {
		if (!enableCall) return

		enableCall = false
		callback.apply(this, args)
		setTimeout(() => (enableCall = true), interval)
	}
}

export const initStatus = names => {
	const statusObj = names.reduce(
		(prev, name) => ({
			...prev,
			[name]: {
				name,
				isLoading: false,
				isSuccess: false,
				isError: false,

				message: '',
				statusCode: null,
			},
		}),
		{}
	)
	return statusObj
}
export const defaultPermissions = userType => {
	if (userType == 'merchant') {
		return {
			read: [
				'banking',
				'pos',
				'analytics',
				'orders',
				'items',
				'offers',
				'pendingItems',
				'pendingOffers',
				'employees',
				'charities',
				'categories',
				'store_info',
			],
			update: [
				'orders',
				'items',
				'offers',
				'pendingItems',
				'pendingOffers',
				'employees',
				'charities',
				'categories',
				'store_info',
			],

			create: ['items', 'offers', 'employees', 'categories'],

			delete: [
				'items',
				'offers',
				// 'pendingItems',
				//  'pendingOffers',
				'employees',
				'categories',
			],

			approve: ['items', 'offers'],
		}
	}
	if (userType == 'employee') {
		return {
			read: [
				// 'banking',
				// 'pos',
				// 'analytics',
				'orders',
				'items',
				'offers',
				'pendingItems',
				'pendingOffers',
				// 'employees',
				'charities',
				'categories',
				'store_info',
			],
			update: [
				'orders',
				// 'items',
				// 'offers',
				// 'pendingItems',
				// 'pendingOffers',
				// 'employees',
				'charities',
				'categories',
				// 'store_info',
			],

			create: [
				'items',
				'offers',
				//  'employees',
				//  'categories'
			],

			delete: [
				// 'items',
				// 'offers',
				// 'pendingItems',
				// 'pendingOffers'
				// 'employees',
				// 'categories'
			],

			approve: [
				// 'items',
				// 'offers'
			],
		}
	}
	return {
		read: [],
		update: [],
		create: [],
		delete: [],
		approve: [],
	}
}
export const checkPermissions = (permissions, permissionQuery, findOne = false) => {
	/*
    Arg Checks
    */

	if (!permissionQuery || !permissions) return { hasPermission: false, isApproved: false }
	if (Object.keys(permissionQuery).length == 0) return { hasPermission: false, isApproved: false }
	if (Object.values(permissionQuery).some(values => !Array.isArray(values)))
		return { hasPermission: false, isApproved: false }

	let isApproved = true
	let hasPermission = true

	const queryFields = Object.keys(permissionQuery)

	if (!findOne) {
		queryFields.forEach(field => {
			if (permissionQuery[field].some(value => !permissions[field].includes(value)))
				hasPermission = false
			if (
				permissionQuery[field].some(
					value =>
						!['create', 'update', 'delete'].includes(field) &&
						['items', 'offers'].includes(value) &&
						!permissions.approve?.includes(value)
				)
			)
				isApproved = false
		})
		return { hasPermission, isApproved }
	} else {
		hasPermission = false
		isApproved = queryFields.forEach(field => {
			// console.log(permissionQuery[field], permissions[field])
			if (permissionQuery[field].some(value => permissions[field].includes(value)))
				hasPermission = true
			// TBD: Approve logic
		})
		return { hasPermission, isApproved: false }
	}
}
// const utils =
export default {
	handleError,
	handleSuccess,
	handleLoading,
	getAuth,
	rejectWithValue,
	debounce,
	throttle,
	clearState,
	initStatus,
	defaultPermissions,
	checkPermissions,

	handleStatus,
}
